import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from "rxjs";

import { map } from 'rxjs/operators';
import { searchFilter } from 'src/app/shared/models/search-filter';

@Injectable()
export class OrderService {

  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  private webMasterId: string | null = null;

  constructor(private http: HttpClient) { 
    this.webMasterId = localStorage.getItem('webMasterId');
  }

  sendOrder(fc, warehouseId, orderId, warehouse, eskyWarehouseName, shippingCode, eskyshippingCode) {
    let params = new HttpParams()
    .append('orderId', orderId)
    .append('fc', fc)
    .append('warehouseId', warehouseId)
    .append('shippingCode', shippingCode)
    .append('eskyshippingCode', eskyshippingCode)
    .append('warehouse', warehouse)
    .append('eskyWarehouseName', eskyWarehouseName);


    return this.http.post(
      'api/orders/createorder', {params})
  }
  quicksendOrder(orderId) {
    let params = new HttpParams()
    .append('orderId', orderId);



    return this.http.post(
      'api/orders/quickcreateorder', {params})
  }
  getOpenorders() {

    return this.http.get('api/orders/open').pipe(map((res: Response) => res));
  }
  getExceptionOrders() {

    return this.http.get('api/orders/exception').pipe(map((res: Response) => res));
  }
  getProcessingOrdersPageable(page, size) {

    return this.http.get('api/orders/getProcessingOrdersPageable?page=' + page + '&size=' + size).pipe(map((res: Response) => res));
  }

  getLatestShippedOrders() {

    return this.http.get('api/orders/getlatestshipped').pipe(map((res: Response) => res));
  }

  getAbnormalOrders(page, size) {

    return this.http.get('api/orders/abnormal?page=' + page + '&size=' + size).pipe(map((res: Response) => res));
  }
  getDeletedOrders(page, size) {

    return this.http.get('api/orders/deleted?page=' + page + '&size=' + size).pipe(map((res: Response) => res));
  }
  getFilteredOrders(page, size) {

    return this.http.get('api/orders/getFilteredOrders?page=' + page + '&size=' + size).pipe(map((res: Response) => res));
  }
  getcolumn() {
    return this.http.get('api/orders/pcolumns').pipe(map((res: Response) => res));
  }

  savecolumns(data) {
    return this.http.post(
      'api/orders/savecolmuns',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  update() {
    return this.http.post(
      'api/orders/update',
      this.headerOptions
    )
  }
  refresh(country, sku, acceptmultiple) {
    let params = new HttpParams()
    .append('country', country)
    .append('sku', sku)
    .append('acceptmultiple', acceptmultiple);
    return this.http.post(
      'api/orders/refresh', {params})
  }
  advancedRefresh(countries, sku, acceptmultiple, refreshOption) {
    let params = new HttpParams()
    .append('countries', countries)
    .append('sku', sku)
    .append('acceptmultiple', acceptmultiple)
    .append('refreshOption', refreshOption)
    return this.http.post(
      'api/orders/advancedRefresh', {params})
  }
  updatecustomer(data) {
    return this.http.post(
      'api/orders/upcustomer',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  updateitem(data) {
    return this.http.post(
      'api/orders/upitem',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  warehouses() {

    return this.http.get('api/config/warehouses').pipe(map((res: Response) => res));;
  }
  shipping(w, fc) {

    return this.http.get('api/config/shippingMethods?warehouse=' + w + '&fc=' + fc).pipe(map((res: Response) => res));;
  }
  //get fb order by ID
  getOrder(orderId: number) {
    return this.http.get('api/orders/getorder?orderId=' + orderId).pipe(map((res: Response) => res));

  }
  createChildenOrders(parentOrderId, children) {
    return this.http.post(
      'api/orders/createChildrenOrders?parentOrderId=' + parentOrderId,
      JSON.stringify(children),
      this.headerOptions
    )
  }
  //get processing orders of all my drop shipping companies
  getComapnyDropShippingProcessingOrders() {

    return this.http.get('api/orders/getdropshippingprocessing').pipe(map((res: Response) => res));
  }

  //get shipped orders of all my drop shipping companies
  getComapnyDropShippingShippedOrders() {

    return this.http.get('api/orders/getdropshippingshipped').pipe(map((res: Response) => res));
  }
  getComapnyDropShippingAbnormalOrders() {

    return this.http.get('api/orders/getdropshippingabnormal').pipe(map((res: Response) => res));
  }

  CalculatePickAndPack(orderId) {
    return this.http.post('api/orders/calculatepickandpack?orderId=' + orderId, this.headerOptions)
  }
  deleteOrder(orderId) {
    return this.http.post('api/orders/deleteOrder?orderId=' + orderId, this.headerOptions);
  }
  searchShippedOrders(orderId, fromDate, tillDate, country) {
    //meeeeeeeeeeeeeeee to be checked { search: params }
    let params= new HttpParams()
    .append('orderId', orderId)
    .append('fromDate', fromDate)
    .append('tillDate', tillDate)
    .append('country', country);
    
    return this.http.get('api/orders/filterShippedOrders', { params }).pipe(map((res: Response) => res))

  }
  getNbrOpenOrders() {
    return this.http.get('api/orders/getNbrOpenOrders').pipe(map((res: Response) => res));
  }
  getNbrExceptionOrders() {
    return this.http.get('api/orders/getNbrExceptionOrders').pipe(map((res: Response) => res));
  }
  getNbrDeletedOrders() {
    return this.http.get('api/orders/getNbrDeletedOrders').pipe(map((res: Response) => res));
  }
  getNbrOrdersByFcStatus(status) {
    return this.http.get('api/orders/getNbrOrdersByFcStatus?status=' + status).pipe(map((res: Response) => res));
  }
  getNbrFilteredOrders() {
    return this.http.get('api/orders/getNbrFilteredOrders').pipe(map((res: Response) => res));
  }

  freezeOrder(orderId, date, reason) {

    return this.http.post(
      'api/orders/freeze?orderId=' + orderId + '&date=' + date + '&reason=' + reason, this.headerOptions
    )

  }
  getFrozenOrders() {
    return this.http.get('api/orders/frozen').pipe(map((res: Response) => res));
  }
  getNbrFrozenOrders() {
    return this.http.get('api/orders/getNbrFrozenOrders').pipe(map((res: Response) => res));
  }

  getNbrTodayFrozenOrders() {
    return this.http.get('api/orders/getDailyFrozenOrders').pipe(map((res: Response) => res));
  }
  updateOrderNotes(data) {
    return this.http.post(
      'api/orders/updateOrderNotes',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  interceptOrder(orderId) {
    return this.http.post(
      'api/orders/cancelOrder?orderId=' + orderId, this.headerOptions
    )
  }

  sendFrozenToDraft(orderId) {
    return this.http.post('api/orders/sendFrozenOrdertoDraft?orderId=' + orderId, this.headerOptions)
  }

  createRma(rma) {
    return this.http.post(
      'api/rma/createRma',
      JSON.stringify(rma),
      this.headerOptions
    )
  }
  deleteLineItem(lineItemId) {
    return this.http.post('api/orders/deleteLineItem?id=' + lineItemId, this.headerOptions);
  }
  addLineItem(orderId, sku, qty) {

    return this.http.post('api/orders/addLineItem?orderId=' + orderId + '&sku=' + sku + '&qty=' + qty, this.headerOptions).pipe(map((res: Response) => res));
  }
  //get order by orderId shop format expl shopify: #1245
  getOrdersByShopOrderIdAndStatus(shopOrderId, orderStatus) {
    
    //meeeeeeeeeeeeeeee to be checked { search: params }
    let params = new HttpParams()
    .append('shopOrderId', shopOrderId)
    .append('orderStatus', orderStatus);
    return this.http.get('api/orders/getOrdersByShopOrderId', { params }).pipe(map((res: Response) => res));

  }

  getOpenOrdersPageable(page, size) {
    return this.http.get('api/orders/getopenOrdersPageable?page=' + page + '&size=' + size).pipe(map((res: Response) => res));

  }

  updateOrderStatusOpen(id) {
    return this.http.post('api/orders/updateOrderStatusOpen?orderId=' + id, this.headerOptions)
  }

  getExceptionOrdersPageable(page, size) {

    return this.http.get('api/orders/getExceptionOrdersPageable?page=' + page + '&size=' + size).pipe(map((res: Response) => res));
  }
   
    getOrderReports(filterParams:any) {
    console.log("filterParams", filterParams);
    return this.http.post('api/orders/getOrderReports', filterParams, {
    }).pipe(map((res: Response) => res));
  }
  getPayoutByCompanies(companyIds: number[]) {
    const requestPayload = { companyIds };

    return this.http.post('api/orders/CostsByCompanyIds', requestPayload, {
    }).pipe(map((res: Response) => res));
  }

  
  getCountries(webmasterId?: string) {
   
    const url = this.webMasterId ? `api/orders/getCountries?webmaster=${this.webMasterId}` : 'api/orders/getCountries';
    return this.http.get(url);
  }
  
  
  getCities(webMasterId?: string) {
    const url = this.webMasterId ? `api/orders/getCities?webmaster=${this.webMasterId}` : 'api/orders/getCities';
    return this.http.get(url);
  }
  

  getProvinces(webmasterId?: string) {
    const url = this.webMasterId ? `api/orders/getProvinces?webmaster=${this.webMasterId}` : 'api/orders/getProvinces';
    return this.http.get(url);
  }

  getTotalRevenue(filterParams) {
    console.log("filterParams", filterParams);
  
    // Helper function to filter out null keys
    const removeNullKeys = (obj) => {
      const filteredObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== null) {
          filteredObj[key] = obj[key];
        }
      }
      return filteredObj;
    };
  
    const filteredParams = removeNullKeys(filterParams);
    console.log("filteredParams", filteredParams);
  
    return this.http.post('api/orders/Costs', filteredParams);
  }

  exportOrdersToExcel(status: string[],companyIds: number[] | null , webMasterId: string | null = null) {
    let url = `api/orders/exportOrderByStatus?status=${status}`;
    if (webMasterId !== null) {
      url += `&webmaster=${webMasterId}`;
    } else if (companyIds !== null) {
      url += `&companyIds=${companyIds.join(',')}`;
    } else {
      url += `&companyIds=`;
    }
    return this.http.get(url, { responseType: 'arraybuffer' }).pipe(
      map((response: ArrayBuffer) => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = status + '-orders.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
    );
  }
  getCountriesByCompanies(companyIds: number[]) {
    let url = 'api/orders/getCountriesByCompanies';
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
  }

  getCountriesByWebMasters(webMaster: string[]) {
    let url = 'api/orders/getCountriesByWebMasters';
    if (webMaster && webMaster.length > 0) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
  }

  getCitiesByWebMasters(webMaster: string[]) {
    let url = 'api/orders/getCitiesByWebMasters';
    if (webMaster && webMaster.length > 0) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url).pipe(map((res: any) => res));
  }

  getProvincesByWebMasters(webMaster: string[]) {
    let url = 'api/orders/getProvincesByWebMasters';
    if (webMaster && webMaster.length > 0) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url).pipe(map((res: any) => res));
  }
  

  getCitiesByCompanies(companyIds: number[]) {
    let url = 'api/orders/getCitiesByCompanies';
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
  }


  getProvincesByCompanies(companyIds: number[]) {
    let url = 'api/orders/getProvincesByCompanies';
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
  }
  searchOrders(searchFilter, page, size) {
    console.log("search filter DTO ",searchFilter)
    return this.http.post('api/Search/', searchFilter, {
      params: {
        page: page,
        size: size
      }
    });
  }
  searchOrdersCount(searchFilter) {
    console.log("search filter DTO ",searchFilter)
    return this.http.post('api/Search/searchOrdersCount', searchFilter);
  }
  
}
